import type { RouteRecordRaw } from 'vue-router'
import { aggregationRoutes } from './router/aggregationRoutes'
import { hotelRoutes } from './router/hotelRoutes'
import { orderRoutes } from './router/orderRoutes'

/**
 * 获取动态打包域全部路由（供应用包挂载，路由懒加载）
 * 路由分文件维护：hotelRoutes 由 PLAN-H5-01 提交（已展开）、orderRoutes 由 PLAN-H5-03 提交（已展开）；
 * 不包含收银台路由（D-01 2026-10-14 改判：收银台在 packages/pay 新增 /h5-pay/dynamic-package-cashier，
 * 域内经跨应用 URL 跳转进入，依赖规则禁止 domains 引用 packages）
 */
export function getDynamicPackageRoutes(): RouteRecordRaw[] {
  return [...aggregationRoutes, ...hotelRoutes, ...orderRoutes]
}
